import env from '../config/env';
import { patch, PATHS } from '../utils/api';

const endTimer = async (): Promise<void> => {
  const url = PATHS.newMembers.endTimerSelf;
  return patch(env.NEW_MEMBER_API_URL, {}, url).then((response) => response.data);
};

export { endTimer };
